import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ElementsConsumer, ExpressCheckoutElement } from '@stripe/react-stripe-js';
import CreditCardFormPartial from '../../forms/partials/CreditCardFormPartial';

class CreditCardFormWrapper extends Component {
  render() {
    const {
      toggle,
      showSubmissionError,
      showCancel,
      buttonText,
      buttonColClass,
      onSubmit,
      showName,
      showCoupon,
      signup,
      onCoupon,
      onClearCoupon,
    } = this.props;
    const coupon = signup && signup.validatedCoupon ? signup.validatedCoupon.name : ''
    const isSubscription = signup.membership.billingFrequency !== 'lifetime';

    return (
      <ElementsConsumer>
        {({ stripe, elements }) => <>
          <ExpressCheckoutElement
            options={{
              paymentMethods: {
                googlePay: 'always',
                amazonPay: 'auto',
                applePay: 'always',
                paypal: 'auto'
              },
              buttonType: {
                googlePay: isSubscription ? 'subscribe' : 'buy',
                applePay: isSubscription ? 'subscribe' : 'buy',
              },
              lineItems: [
                {
                  name: signup.membership.nameLong,
                  amount: Math.floor(signup.membership.fullPrice * 100)
                }
              ]
            }}
            onConfirm={ data => {
              onSubmit(
                {
                  stripe,
                  elements,
                  membershipOptionId: signup.membership.id,
                  paymentFailed: data.paymentFailed,
                  failure: data.paymentFailed,
                  paymentMethod: {
                    id: 'WALLET',
                    stripe,
                    elements
                  }
                },
                coupon
              );
            } } />
          <CreditCardFormPartial
            onCancel={toggle}
            stripe={stripe}
            elements={elements}
            showSubmissionError={showSubmissionError}
            showCancel={showCancel}
            buttonText={buttonText}
            buttonColClass={buttonColClass}
            onSubmit={onSubmit}
            initialValues={{ nameOnCard: '', coupon, membershipOptionId: signup.membership.id }}
            showName={showName}
            showCoupon={showCoupon}
            signup={signup}
            onCoupon={onCoupon}
            onClearCoupon={onClearCoupon}
          />
        </>}
      </ElementsConsumer>
    );
  }
}

CreditCardFormWrapper.propTypes = {
  toggle: PropTypes.func,
  showSubmissionError: PropTypes.func,
  showCancel: PropTypes.bool,
  showName: PropTypes.bool,
  showCoupon: PropTypes.bool,
  buttonText: PropTypes.string,
  buttonColClass: PropTypes.string,
  onSubmit: PropTypes.func,
  signup: PropTypes.instanceOf(Object),
  onCoupon: PropTypes.func,
  onClearCoupon: PropTypes.func,
};

export default CreditCardFormWrapper;
